import * as React from 'react';

export default function (props) {
  const {
    classes,
    target,
    text,
    url = null
  } = props;

  return (
    <a href={url} className={classes} target={target}>{text}</a>
  );
}
